<script>
  import { user, pageToLoad } from "../scripts/stores.js";
  import {
    checkForApprovedUser,
    checkIfUserExists,
    addUserToWorkshopCloud,
    logout,
  } from "../scripts/firebase.js";
  import { onMount } from "svelte";

  let checkStatus = "loading";

  console.log("on page authenticate");

  const checkUser = async (userIn) => {
    const handleError = (err) => {
      console.log("Handlin an error:");
      console.log(err);
    };
    console.log(userIn);
    // const exists = await checkIfUserExists(userIn.uid).catch(handleError);
    // if (exists) {
    //   checkStatus = "found";
    //   console.log("User already exists");
    //   pageToLoad.set("dashboard");
    //   return;
    // }
    const result = await checkForApprovedUser(userIn.email).catch(handleError);
    if (!result) {
      checkStatus = "failed";
      console.log("Not in list of approved users");
      logout();
      return;
    }
    checkStatus = "found";
    console.log("found in list of approved users");
    console.log(result);
    const workshops = result.workshops;

    workshops.forEach(async (workshopId) => {
      await addUserToWorkshopCloud({
        workshopID: workshopId,
        username: $user.displayName,
      });
    });
    pageToLoad.set("dashboard");
    return;
  };

  // const tempSignup = async () => {
  //   await addUserToWorkshopCloud({
  //     workshopID: "QI8Ll3BPyWCUlwFiPEaQ",
  //     username: "bobby joe",
  //   });
  //   pageToLoad.set("dashboard");
  // };

  $: $user.loggedIn && checkUser($user);
</script>

<main class="page">
  {#if checkStatus == "loading"}
    <h2>Checking our records...</h2>
  {:else if checkStatus == "found"}
    <h2>You're good to go!</h2>
  {:else}
    <h2>Sorry, we couldn’t find that email address in our records.</h2>
    <p>
      Did you receive an email from me at this email address? If so, please
      contact me at nate@synthase.cc. If not, please try again with a different
      email address.
    </p>
    <div class="button-primary" on:click={() => pageToLoad.set("login")}>
      Try again
    </div>
  {/if}
</main>

<style>
</style>
